<template>
  <div>
    <v-btn
      v-if="type === 'Franchise'"
      :width="width"
      :height="height"
      fab
      dark
      depressed
      color="#4CA22F"
    >
      <!-- <i style="font-size: 20px" class="fas fa-shopping-basket"></i> -->
      <span class="material-symbols-outlined"> storefront </span>
    </v-btn>

    <v-btn
      v-if="type === 'Promotion'"
      :width="width"
      :height="height"
      fab
      dark
      depressed
      color="#F1545B"
    >
      <!-- <i style="font-size: 20px" class="fas fa-tag"></i> -->
      <span class="material-symbols-outlined"> sell </span>
    </v-btn>

    <v-btn
      v-if="type === 'Case'"
      :width="width"
      :height="height"
      fab
      dark
      depressed
      color="#FDB913"
    >
      <!-- <i style="font-size: 20px" class="fas fa-file-edit"></i> -->
      <span class="material-symbols-outlined"> edit_document </span>
    </v-btn>

    <v-btn
      v-if="type === 'News'"
      :width="width"
      :height="height"
      fab
      dark
      depressed
      color="#5ECDE6"
    >
      <!-- <i style="font-size: 20px" class="fas fa-bullhorn"></i> -->
      <span class="material-symbols-outlined"> library_books </span>
    </v-btn>
    <v-btn
      v-if="type === 'system'"
      :width="width"
      :height="height"
      fab
      dark
      depressed
      color="#637381"
    >
      <!-- <i :style="{ fontSize: iconSize }" class="fas fa-cog"></i> -->
      <span class="material-symbols-outlined"> settings </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 40,
    },
    height: {
      type: Number,
      default: 40,
    },
    iconSize: {
      type: String,
      default: "18px",
    },
  },
};
</script>

<style></style>
